import { ImageBaseUrl } from '../../../../../../constants'
import { Oval } from 'react-loader-spinner'
import { Message } from '../../../../../../types/api'

const AudioMessage = ({ message }: { message: Message }) => {
  const audioUrl = message.file_url
    ? message.file_url.startsWith('http://') || message.file_url.startsWith('https://')
      ? message.file_url
      : `${ImageBaseUrl}${message.file_url}`
    : ''

  if (!audioUrl) {
    return null
  }

  const isUploading = message.uploadStatus === 'uploading'
  const mimeType = message.metadata?.mime_type
  // No numeric progress shown — only spinner

  return (
    <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
      {/* Upload progress overlay */}
      {isUploading && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0, 0, 0, 0.7)',
            borderRadius: '8px',
            zIndex: 10,
          }}
        >
          <Oval
            visible={true}
            height="40"
            width="40"
            ariaLabel="Loading"
            wrapperClass="loader-wrapper"
            color="#0066FF"
          />
        </div>
      )}

      {/* Failed upload overlay */}
      {message.uploadStatus === 'failed' && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(220, 53, 69, 0.9)',
            borderRadius: '8px',
            zIndex: 10,
            color: '#fff',
            fontSize: '11px',
            fontWeight: '600',
          }}
        >
          Upload Failed
        </div>
      )}

      <audio
        controls
        className="chat-media-audio"
        style={{
          opacity: isUploading ? 0.5 : 1,
        }}
      >
        {mimeType && <source src={audioUrl} type={mimeType} />}
        <source src={audioUrl} type="audio/webm" />
        <source src={audioUrl} type="audio/mp4" />
        <source src={audioUrl} type="audio/m4a" />
        <source src={audioUrl} type="audio/wav" />
        <source src={audioUrl} type="audio/ogg" />
        <source src={audioUrl} type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
    </div>
  )
}

export default AudioMessage
